import { Formik } from 'formik';
import { useRouter } from 'next/router';
import { useContext } from 'react';
import * as Yup from 'yup';
import { executeGQL } from '../../lib/api';
import { useTranslation } from '../../lib/i18n';
import { trackEvent } from '../../lib/tracking';
import { Button } from '../common/button';
import { ToastContext } from '../toast/toast-context';
import { PasswordInput } from './fields';

export const SetPwForm = ({ className = '' }) => {
  const { t } = useTranslation();
  const { toast } = useContext(ToastContext);
  const router = useRouter();

  return (
    <div className={className}>
      <h1 className='mb-6 text-center'>{t('setPwHeading')}</h1>

      <div>
        <Formik
          initialValues={{
            password: '',
            password2: '',
          }}
          validationSchema={Yup.object({
            password: Yup.string()
              .required(t('required'))
              .test('len', t('pwMinLen'), (val) => val && val.length > 4),
            password2: Yup.string()
              .required(t('required'))
              .oneOf([Yup.ref('password'), null], t('passwordDoNotMatch')),
          })}
          onSubmit={async (values, { setSubmitting, resetForm, setErrors }) => {
            setSubmitting(true);

            const { errors, hasErrors } = await executeGQL('resetSetPassword', {
              email: router.query.email,
              token: router.query.token,
              password: values.password,
            });
            if (hasErrors) {
              setErrors(errors);
              setSubmitting(false);

              if (errors?.token) {
                toast.show(t('setPwNewTokenRequired'), {
                  type: 'error',
                  timeout: 0,
                  actionLink: '/reset',
                  actionLabel: t('setPwGetNewToken'),
                });
              } else if (errors?.email) {
                toast.show(t('setPwGetChangeEmail'), {
                  type: 'error',
                  timeout: 0,
                  actionLink: '/reset',
                  actionLabel: t('setPwGetNewToken'),
                });
              } else {
                toast.show(t('genericError'), {
                  type: 'error',
                  timeout: 0,
                });
              }
            } else {
              trackEvent({
                category: 'form',
                action: 'submit',
                label: 'set password',
              });
              setSubmitting(false);
              resetForm({});
              toast.show(t('setPwConfirmation'), {
                keepAlive: '/profile',
              });
              router.push('/profile');
            }
          }}
        >
          {(props) => (
            <form className={`mx-auto max-w-md`} onSubmit={props.handleSubmit}>
              <PasswordInput className='mt-2' id='password' name='password' />
              <PasswordInput className='mt-2' id='password2' name='password2' />
              <Button
                loading={props.isSubmitting}
                type='submit'
                className='mt-8'
                filled={true}
              >
                {t('send')}
              </Button>
            </form>
          )}
        </Formik>
      </div>
    </div>
  );
};
